// heroData.js
// فقط دیتای استاتیک بخش trust row و بج‌های شناور روی اسلایدر —
// اسلایدهای اصلی از useGetSliderPageQuery داخل HeroSlider.jsx میان

export const trustItems = [
  {
    id: "verified",
    label: "متخصصان تأیید‌شده",
    path: "M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z",
  },
  {
    id: "fast",
    label: "پاسخ سریع",
    path: "M12 7v5l3 3",
    circle: true, // آیکون این یکی یه دایره پایه داره + مسیر بالا
  },
  {
    id: "secure",
    label: "پرداخت امن",
    path: "M2 10h20",
    rect: true, // آیکون این یکی یه مستطیل پایه داره + خط بالا
  },
];

// بج‌های شیشه‌ای شناور روی گوشه‌های اسلایدر — عدد+برچسب، فعلاً استاتیک
export const sliderBadges = [
  {
    id: "satisfaction",
    value: "٪۹۸",
    label: "رضایت مشتریان",
  },
  {
    id: "response",
    value: "زیر 15 دقیقه",
    label: "میانگین پاسخ‌گویی",
  },
];
